import { TextL, TextS } from 'app/components';
import { StyledContainer } from './EmptyState.styles';
import fileNotFoundIcon from '../../components/Icons/svgs/FileNotFound.svg';
import fileWarningIcon from '../../components/Icons/svgs/FileWarning.svg';

type TEmptyStateProps = {
  title: string;
  subtitle?: string;
  hasMarginTop?: boolean;
  icon?: 'primary' | 'secondary';
};

const EmptyState = ({
  title,
  subtitle,
  hasMarginTop,
  icon,
}: TEmptyStateProps) => {
  // INFO Ícones:
  // Primary: Ícone com lupa
  // Secondary: Ícone de alerta

  return (
    <StyledContainer hasMarginTop={hasMarginTop}>
      <img src={icon === 'secondary' ? fileWarningIcon : fileNotFoundIcon} />
      <TextL style={{ marginBottom: '1rem' }}>{title}</TextL>
      {subtitle ?? <TextS>{subtitle}</TextS>}
    </StyledContainer>
  );
};

export default EmptyState;
